import { UntypedFormGroup } from "@angular/forms";
import { ValidationResult } from "src/app/ui/models/domains/validator/validation-result";

export class CompanyValidator {
  private validationResult = new ValidationResult();

  public getValidationResult(): ValidationResult {
    return this.validationResult;
  }

  public validate(formCompanyRegistration: UntypedFormGroup): ValidationResult {
    const unit = formCompanyRegistration.get("unit").value;
    const headOfficeFiscalNumber = formCompanyRegistration.get("headOfficeFiscalNumber").value;
    const fiscalNumber = formCompanyRegistration.get("fiscalNumber").value;
    const corporateName = formCompanyRegistration.get("corporateName").value;
    const street = formCompanyRegistration.get("street").value;
    const num = formCompanyRegistration.get("number").value;
    const district = formCompanyRegistration.get("district").value;
    const city = formCompanyRegistration.get("city").value;
    const region = formCompanyRegistration.get("region").value;
    const zipCode = formCompanyRegistration.get("zipCode").value;
    const companyType = formCompanyRegistration.get("companyType").value;
    
    if (!unit) {
      this.validationResult.addErrorMessage("Unidade é obrigatório");
    } else if (!fiscalNumber) {
      this.validationResult.addErrorMessage("CNPJ da Unidade é obrigatório");
    } else if (!headOfficeFiscalNumber) {
      this.validationResult.addErrorMessage("CNPJ da Matriz é obrigatório");
    } else if (!corporateName) {
      this.validationResult.addErrorMessage("Razão Social é obrigatório");
    } else if (!street) {
      this.validationResult.addErrorMessage("Endereço é obrigatório");
    } else if (!num) {
      this.validationResult.addErrorMessage("Número é obrigatório");
    } else if (!district) {
      this.validationResult.addErrorMessage("Bairro é obrigatório");
    } else if (!city) {
      this.validationResult.addErrorMessage("Cidade é obrigatório");
    } else if (!region) {
      this.validationResult.addErrorMessage("UF é obrigatório");
    } else if (!zipCode) {
      this.validationResult.addErrorMessage("CEP é obrigatório");
    } else if (companyType === null || companyType === "" || companyType === undefined) {
      this.validationResult.addErrorMessage("Tipo de Empresa é obrigatório");
    }

    return this.validationResult;
  }
}
